import {
  getStartup_Form,
  getStartup_IsLoading,
  getStartup_isUnavailable,
  getStartup_isUnavailableMessage,
  getStartup_Url,
} from './selectors';
import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { CheckAvailabilityRequestAction, StartupAction } from './actions';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import {
  AppButtonComponent,
  EntryFieldComponent,
  Helper,
} from '@ifaa-components/ui-components';
import { Router } from '@angular/router';
import { ComponentBase } from 'src/app/views/component-base';
import { AppState } from 'src/app/store/app.states';
import { SystemConfigurationRequestAction } from 'src/app/store/common/common.actions';
import { MsalService } from '@azure/msal-angular';
import { FormGroupState, NgrxFormsModule } from 'ngrx-forms';
import { SMRTStartupValidationModel } from './state';
import { NgIf, AsyncPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { AnimateCssDirective } from 'src/app/modules/shared/directives/animatecss.directive';
import { AppButtonDirective } from 'src/app/modules/shared/directives/appbutton.directive';
import { InputScrollDirective } from 'src/app/modules/shared/directives/input-scroll.directive';
import { MessagePipe } from 'src/app/modules/shared/pipes/message';
import { TenantConfigPipe } from 'src/app/modules/shared/pipes/tenantconfig';

@Component({
  selector: 'app-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.scss'],
  imports: [
    NgIf,
    MatProgressSpinner,
    AnimateCssDirective,
    NgrxFormsModule,
    FormsModule,
    ReactiveFormsModule,
    EntryFieldComponent,
    InputScrollDirective,
    AppButtonComponent,
    AppButtonDirective,
    AsyncPipe,
    MessagePipe,
    TenantConfigPipe,
    TranslatePipe,
  ],
})
export class StartupComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  errorMsg = '';
  form$ = this.store.pipe(select(getStartup_Form));
  isUnavailable$ = this.store.pipe(select(getStartup_isUnavailable));
  isUnavailableMessage$ = this.store.pipe(
    select(getStartup_isUnavailableMessage)
  );
  url$ = this.store.pipe(select(getStartup_Url));
  isLoading$ = this.store.pipe(select(getStartup_IsLoading));

  helper = new Helper();
  constructor(
    public store: Store<AppState>,
    private recaptchaV3Service: ReCaptchaV3Service,
    private msalService: MsalService,
    private router: Router
  ) {
    super();
    this.checkUserIsLoggedIn();
  }

  checkUserIsLoggedIn() {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      this.router.navigate(['dashboard']);
    }
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.dispatch(this.store, SystemConfigurationRequestAction());
    this.dispatch(this.store, CheckAvailabilityRequestAction());
    this.sub = this.url$.subscribe((x) => {
      if (x) {
        window.location.href = x;
      }
    });

    var error = localStorage.getItem('login-error');
    if (error) {
      switch (error) {
        case 'Unauthorized':
          this.errorMsg = "Sorry, you're not authorized to access this portal";
          break;
      }
    }
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  validateUser(login: FormGroupState<SMRTStartupValidationModel>) {
    if (login.isInvalid) return;

    console.log('===== validateUser =====');
    this.sub = this.recaptchaV3Service
      .execute('validateUser')
      .subscribe((token) => {
        console.log('===== validateUser:' + token);
        var clone = this.helper.clone(login.value);
        clone.token = token;
        clone.email = login.value.email;
        this.store.dispatch(StartupAction({ payload: clone }));
      });
  }
}
